import { Factory } from 'miragejs';
import { subHours, addHours, getUnixTime } from 'date-fns';

export default Factory.extend({
  startTime: getUnixTime(subHours(new Date(), 1)),
  endTime: getUnixTime(addHours(new Date(), 1)),
});
